import i18n from "i18next";

/**
 * Checks if a question matches the translation key in any available language
 * @param question - The question string to check
 * @param translationKey - The translation key to match against (default: "chatjess.ui.thanksForAnswering")
 * @returns true if the question matches the translation in any language
 */
export const questionMatchesAnyLanguage = (
  question: string | undefined,
  translationKey: string = "chatjess.ui.thanksForAnswering",
): boolean => {
  if (!question) return false;

  const availableLanguages = i18n.options.resources
    ? Object.keys(i18n.options.resources)
    : [];

  return availableLanguages.some(
    lang => question === i18n.t(translationKey, { lng: lang }),
  );
};
